import clsx from 'clsx';
import { Tooltip } from '../tooltip';
import { useRowOverflow } from '../../hooks/useRowOverflow';
import styles from './OverflowPills.module.css';

export function OverflowPills({
  items,
  className,
  wrapClassName,
  pillClassName,
  ariaLabel,
  maxRows = 2,
  tooltipItemTransform,
  showOverflowTooltip = true,
  identityKey,
  rowStyle,
}) {
  const {
    measureRef,
    setItemRef,
    overflowRef,
    visibleItems,
    hasOverflow,
    hiddenCount,
    hiddenItems,
  } = useRowOverflow(items, {
    maxRows,
    identityKey,
  });

  const renderOverflowIndicator = () => {
    if (!hasOverflow) return null;

    if (!showOverflowTooltip) {
      return <span className={clsx(pillClassName)}>+{hiddenCount}</span>;
    }

    return (
      <Tooltip
        arrowAlign="center"
        bubbleAlign="arrow-offset"
        arrowOffsetPx={12}
        content={
          <div className={clsx(styles.tooltipList)} role="list">
            {hiddenItems.map((item, index) => (
              <div
                key={`${item}-${index}`}
                className={clsx(styles.tooltipListItem)}
                role="listitem"
              >
                <span className={clsx(styles.tooltipBullet)} aria-hidden />
                <span className={clsx(styles.tooltipListText)}>
                  {tooltipItemTransform ? tooltipItemTransform(String(item)) : String(item)}
                </span>
              </div>
            ))}
          </div>
        }
      >
        <button
          className={clsx(pillClassName, styles.pillWithTooltip, styles.plusPill)}
          type="button"
          aria-label={`Show ${hiddenCount} more`}
        >
          +{hiddenCount}
        </button>
      </Tooltip>
    );
  };

  return (
    <div className={clsx(styles.pillsWrap, wrapClassName)} aria-label={ariaLabel}>
      <div className={clsx(styles.row, className)} style={rowStyle}>
        {visibleItems.map((item, index) => (
          <span key={`${item}-${index}`} className={clsx(pillClassName)}>
            {item}
          </span>
        ))}
        {renderOverflowIndicator()}
      </div>

      <div
        ref={measureRef}
        className={clsx(styles.row, className, styles.pillsMeasure)}
        style={rowStyle}
        aria-hidden
      >
        {items.map((item, index) => (
          <span key={`${item}-${index}`} ref={setItemRef(index)} className={clsx(pillClassName)}>
            {item}
          </span>
        ))}
        <span ref={overflowRef} className={clsx(pillClassName)}>
          +0
        </span>
      </div>
    </div>
  );
}
